import { css } from 'styled-components';

const styles = css`
  &.bia-tile {
    margin: 8px;
    width: 136px;
    height: 169px;
    .bia-tileWrapper {
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
      min-height: 108px;
      align-items: center;
      justify-content: center;
    }
    .product-image-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      justify-content: center;
      cursor: pointer;
    }
    .images-container {
      display: flex;
      align-items: center;
      justify-content: center;
      #video-player-animation {
        position: relative;
        width: 56px;
        height: 75px;
        margin-bottom: -18px;
      }
      .video-play-button {
        display: none;
      }
    }
    .product-image {
      width: 120px;
      height: 153px;
    }

    .show-more-numbers {
      width: 22px;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .more-product-counts {
      background: #edf5fb;
      border-radius: 8px;
      padding: 21px 12px;
    }
    .order-status-details {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED_2};
    }
    .order-status-date {
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXM};
    }
    .order-status-date-expire {
      color: #1a1a1a;
    }
    .order-status-date-default {
      color: #26762c;
    }
    .order-pickup-location {
      color: #26762c;
    }
    .pickup-location-detail-text {
      margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.XXM};
    }
    .order-status-expire {
      color: #c8102e;
    }
    .order-status-default {
      color: #1a1a1a;
    }
    .order-status {
      text-transform: capitalize;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 110px;
      height: 120px;

      .product-image-container {
        width: 80px;
        height: 102px;
      }
      .product-image {
        width: 80px;
        height: 102px;
      }
    }
  }
`;

export default styles;
